type Props = {
	className?: string
	size?: number
}

export const SearchGlassIcon = ({ className, size = 16 }: Props) => (
	<span className={className} aria-hidden>
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<circle cx="11" cy="11" r="7" />
			<line x1="21" y1="21" x2="16.65" y2="16.65" />
		</svg>
	</span>
)
